import React, { Component } from 'react';
const iconArrow = require('../../../../public/img/miami/ui/icon-arrow-forward.png');
const iconArrowPrimary = require('../../../../public/img/miami/ui/icon-arrow-forward-primary.png');

class BackButtonMiami extends Component {
  renderBackButton = () => {
    let icon = iconArrow;
    let textColor = "#95268e"
    if (this.props.colorPallette === "adaptive") {
      icon = iconArrowPrimary;
      textColor = "#006699";
    }
    return (
      <div>
        <div style={{ position:"absolute", top:'1vh', marginLeft: '.3vh', height:"2vh", width:"100%" }}>
          <span style={{ position:"absolute", top:"0.208333333vh", fontSize: '.96vh', color: textColor, right: "0.91145833333333333333vh" }}>BACK</span>
        </div>
        <div style={{ position: "absolute", top: "2.3vh", marginLeft: '.3vh', marginTop: "0.5vh", left: ".231481481481481481vh", width:"100%" }}>
          <img className="fliph" alt="back" style={{ position: "absolute", width: '1.5vh', height: '1.5vh', right: "1.5625vh" }} src={icon} />
        </div>
      </div>
    )
  }

  render() {
    return (
      <div>
        {this.props.mode === "video" ?
          <div onMouseDown={() => this.props.clickAction()} style={{ position: 'fixed', height: this.props.height, width: this.props.width, top: this.props.top, borderRadius: this.props.border, left: this.props.left }}>
            {this.renderBackButton()}
          </div>
          :
          <div onMouseDown={() => this.props.clickAction()} style={{ position: 'fixed', height: this.props.height, width: this.props.width, backgroundColor: 'white', top: this.props.top, borderTopRightRadius: this.props.border, borderBottomRightRadius: this.props.border }}>
            <div>
              {this.renderBackButton()}
            </div>
          </div>
        }
      </div>
    )
  }
}

export default BackButtonMiami




// WEBPACK FOOTER //
// ./src/Components/Theme/Miami/BackButtonMiami.js